/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const foodHandlerQuestions = [
    {
        id: questionIds.EverHadTyphoidFever,
        questionText: "Typhoid fever/para-typhoid fever",
    },
    {
        id: questionIds.EverHadTyphoidFeverFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadBowelDisorders,
        questionText: "Bowel disorders e.g. dysentery, persistent diarrhoea",
    },
    {
        id: questionIds.EverHadBowelDisordersFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadTuberculosis,
        questionText: "Tuberculosis",
    },
    {
        id: questionIds.EverHadTuberculosisFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadAsthmaOrChestInfection,
        questionText: "Asthma or any other chest infection",
    },
    {
        id: questionIds.EverHadAsthmaOrChestInfectionFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadRecurringSkinDisorders,
        questionText: "Recurring skin disorders",
    },
    {
        id: questionIds.EverHadRecurringSkinDisordersFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadAllergicReactions,
        questionText: "Allergic reactions (including to nuts)",
    },
    {
        id: questionIds.EverHadAllergicReactionsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadBackNeckArmWristProblems,
        questionText: "Persistent back, neck, arm or wrist problems",
    },
    {
        id: questionIds.EverHadBackNeckArmWristProblemsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadDeafnessDefectiveVision,
        questionText: "Deafness or defective vision",
    },
    {
        id: questionIds.EverHadDeafnessDefectiveVisionFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EverHadBlackoutsDizzySpells,
        questionText: "Blackouts or dizzy spells",
    },
    {
        id: questionIds.EverHadBlackoutsDizzySpellsFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SkinInfectionWithinLastTwoWeeks,
        questionText: "A skin infection",
    },
    {
        id: questionIds.SkinInfectionWithinLastTwoWeeksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DiarrhoeaVomitingWithinLastTwoWeeks,
        questionText: "Diarrhoea and/or vomiting",
    },
    {
        id: questionIds.DiarrhoeaVomitingWithinLastTwoWeeksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.EarEyeGumInfectionWithinLastTwoWeeks,
        questionText: "An infection involving ears, eyes or gums",
    },
    {
        id: questionIds.EarEyeGumInfectionWithinLastTwoWeeksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ContactWithTyphoidWithinLastTwoWeeks,
        questionText: "Contact with anyone who may have had typhoid or paratyphoid fever",
    },
    {
        id: questionIds.ContactWithTyphoidWithinLastTwoWeeksFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.TyphoidCarrier,
        questionText: "Have you ever had, or are you now known to be a carrier of typhoid or paratyphoid?",
    },
    {
        id: questionIds.TyphoidCarrierFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DiarrhoeaVommitingLast7Days,
        questionText: "Have you now, or have you over the last seven days, suffered from diarrhoea and/or vomiting?",
    },
    {
        id: questionIds.DiarrhoeaVommitingLast7DaysFurtherDetails,
        questionText: "Please provide details",
    }
];
